import API_URLS from '../../constants/api-urls';
import axios from '../../utils/axios';
import formatPriceToFloat from '../../utils/price/format-price-to-float';

type SavePriceArgs = {
    bundleId: number;
    price: number;
};

export const savePrice = ({ price, bundleId }: SavePriceArgs) =>
    axios.post(API_URLS.OWN_MATERIALS.SET_PRICE, {
        materialId: bundleId,
        price: formatPriceToFloat(price)
    });
